module.exports = __webpack_public_path__ + "static/media/OPRS-Atlantic_v2.b579810e.jpg";